/**
 * <b>[IMPORTANT]</b>: The shared worker is built separately from other projects.
 * If there are any changes made to this file or shared.worker.ts,
 * it should be built and deployed independently using the appropriate GitHub Workflow.
 */

export interface SharedWorkerMessage {
    type: SharedWorkerMessageType;
    platform: string;
    payload: any;
}

export interface SharedWorkerSocketMessage {
    action: SocketMessageAction|"message";
    scope: {
        namespace: string;
        rooms?: string[];
    }[]
    critical?: boolean;
    data?: {
        [key: string]: any;
    }
}

export interface SharedWorkerSocketInboundMessage extends Omit<SharedWorkerSocketMessage, "scope"> {
    messageId: string;
    namespace: string;
    rooms?: string[];
}

export interface SocketConnectionLocalParams {
    labId?: string;
    companyPersonnelId?: string;
}

export interface SocketUpdateMessageData {
    id: string;
    new?: boolean;
    className: string;
    diff: { [key: string]: any };
}
export interface SocketAlertMessageData {
    alert: {
        message: string;
        level?: "info" | "warning" | "error" | "success";
        sound?: boolean;
    };
    fireAt?: number;
    cron?: string;
    alertGroupId?: string;
    debounceTime?: number;
}

export interface SharedWorkerLabMessage { lab: string; platforms?: string[]; companyPersonnelId?: string }
export interface SharedWorkerLabsMessage { labs: string[] }
export interface SharedWorkerConnectMessage {url: string; reset?: boolean; retryCount?: number}
export interface SharedWorkerConnectionMessage {id: string; socket?: boolean}
export interface SharedWorkerSocketReconnectMessage {retryCount: number}
export type SharedWorkerRoomMessage = string;

export enum SocketMessageAction {
    JOIN = "JOIN",
    LEAVE = "LEAVE",
    UPDATE = "UPDATE",
    ALERT = "ALERT",
}

export type SharedWorkerMessageType = "generic"
    | "connection"
    | "socketMessage"
    | "connect"
    | "disconnect"
    | "lab"
    | "labs"
    | "socketReconnect"
